import { Paper, TextField, Typography } from "@mui/material";
const BodyInputs = ({
  bodyParams = [],
  onBodyChange,
  maxChars = 20,
  title = "Body Parameters",
  labelPrefix = "Parameter",
}) => {
  if (bodyParams.length === 0) return null;

  const handleBodyChange = (index, value) => {
    // Enforce character limit
    if (value.length <= maxChars) {
      onBodyChange?.(index, value);
    }
  };

  return (
    <Paper variant="outlined" sx={{ p: 2, mt: 2 }}>
      <Typography variant="h6" gutterBottom>
        {title}
      </Typography>
      {bodyParams.map((param, index) => (
        <TextField
          size="small"
          key={index}
          fullWidth
          label={`${labelPrefix} ${index + 1}`}
          value={param}
          onChange={(e) => handleBodyChange(index, e.target.value)}
          margin="normal"
          inputProps={{
            maxLength: maxChars,
          }}
          helperText={`${param.length}/${maxChars} characters`}
        />
      ))}
    </Paper>
  );
};

export default BodyInputs;
